"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const mui_1 = require("tss-react/mui");
const useStyles = (0, mui_1.makeStyles)()((theme) => {
    var _a, _b, _c, _d, _e;
    const { palette, shadows, spacing, typography, applyOpacityToHex } = theme;
    const tableBg = (_a = palette.background.paper) !== null && _a !== void 0 ? _a : palette.common.white;
    const txnBg = palette.common.white;
    return {
        settingsBar: {
            display: 'flex',
            alignItems: 'flex-end',
            flexWrap: 'wrap',
            gap: spacing(3),
            padding: '16px 20px',
            backgroundColor: palette.reports.settingsBarBackground,
            borderRadius: 0,
            borderBottom: `1px solid ${palette.cloudyGrey}`,
        },
        menuColumn: {
            display: 'flex',
            flexDirection: 'column',
            alignItems: 'flex-start',
        },
        menuLabel: Object.assign({ marginBottom: 2, paddingLeft: 8 }, typography.caption),
        viewMenuValue: {
            fontSize: 14,
            fontWeight: 400,
        },
        categoryInput: {
            minWidth: 134,
        },
        filtersGroup: {
            paddingTop: 20,
        },
        spacer: {
            flex: 1,
            minWidth: 40,
        },
        selectionBar: {
            display: 'flex',
            alignItems: 'center',
            gap: spacing(1),
            height: '60px',
            paddingLeft: '20px',
            marginTop: '20px',
            backgroundColor: applyOpacityToHex(palette.greyScaleDeprecated[0], 0.1),
            borderTopLeftRadius: 5,
            borderTopRightRadius: 5,
        },
        selectionText: {
            color: palette.primary.main,
            fontWeight: 500,
        },
        tableOuter: {
            marginTop: '20px',
            backgroundColor: palette.common.white,
            border: `1px solid ${palette.divider}`,
            borderTop: 'none',
            borderRadius: 5,
        },
        tableZeroState: {
            marginTop: '20px',
            backgroundColor: palette.common.white,
            border: `1px solid ${palette.divider}`,
            borderBottomLeftRadius: 5,
            borderBottomRightRadius: 5,
            width: '100%',
            margin: 'auto',
            height: 'auto',
            minHeight: 225,
            paddingTop: 40,
            position: 'relative',
        },
        tableOuterWithSelection: {
            marginTop: 0,
            borderTopLeftRadius: 0,
            borderTopRightRadius: 0,
        },
        headRow: {
            backgroundColor: palette.common.white,
            '& > th': {
                borderBottom: `1px solid ${palette.divider}`,
                borderTop: 'none',
            },
        },
        headCell: {
            fontSize: 16,
            fontWeight: 500,
            lineHeight: '30px',
            color: palette.text.primary,
            backgroundColor: tableBg,
            borderTop: 'none',
            borderBottom: `1px solid ${palette.divider}`,
            paddingTop: 8,
            paddingBottom: 8,
        },
        headCellFirst: {
            borderTopLeftRadius: 5,
        },
        headCellLast: {
            borderTopRightRadius: 5,
        },
        tableBgCell: {
            backgroundColor: tableBg,
        },
        rowCell: {
            whiteSpace: 'nowrap',
            overflow: 'hidden',
            textOverflow: 'ellipsis',
            maxWidth: 1,
        },
        rowCellContent: {
            display: 'block',
            whiteSpace: 'nowrap',
            overflow: 'hidden',
            textOverflow: 'ellipsis',
            fontSize: 14,
        },
        tagsEditField: {
            '& .MuiInputBase-root': {
                minHeight: 32,
                height: 32,
                alignItems: 'center',
            },
            '& .MuiInputBase-input': {
                paddingTop: 0,
                paddingBottom: 0,
                lineHeight: '32px',
            },
            '& svg': {
                fontSize: 18,
            },
        },
        clrCellContent: {
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'center',
            minHeight: 28,
        },
        zebraRow: {
            '&.odd': {
                backgroundColor: (_c = (_b = palette.greyScaleDeprecated) === null || _b === void 0 ? void 0 : _b[7]) !== null && _c !== void 0 ? _c : palette.background.default,
            },
        },
        categoryRow: {
            '& > *': {
                backgroundColor: palette.background.default,
                borderBottom: `1px solid ${palette.divider}`,
                padding: '5px !important',
                maxHeight: 20,
            },
        },
        transactionRow: {
            '& > *': {
                backgroundColor: txnBg,
                borderBottom: `1px solid ${palette.divider}`,
                paddingTop: 6,
                paddingBottom: 6,
            },
        },
        groupHeaderCell: {
            backgroundColor: palette.background.default,
        },
        groupHeaderCellWithTopBorder: {
            borderTop: `1px solid ${palette.divider}`,
        },
        groupHeaderText: {
            color: palette.black,
            fontWeight: 500,
            fontSize: 14,
            letterSpacing: 0.3,
        },
        rowKeyText: {
            color: palette.black,
            fontWeight: 500,
            fontSize: 14,
            letterSpacing: 0.3,
            paddingLeft: 4,
        },
        amountText: {
            color: palette.black,
            fontWeight: 500,
            fontSize: 14,
            letterSpacing: 0.3,
        },
        actionIcon: {
            padding: 6,
        },
        filtersButton: {
            backgroundColor: (_e = (_d = palette.greyScaleDeprecated) === null || _d === void 0 ? void 0 : _d[7]) !== null && _e !== void 0 ? _e : palette.grey.level0,
            boxShadow: shadows[2],
            fontSize: 14,
            fontWeight: 400,
        },
        downloadButton: {
            padding: 0,
            boxShadow: shadows[2],
            borderRadius: 4,
            overflow: 'hidden',
            border: `1px solid ${palette.grey.level2}`,
            backgroundColor: palette.common.white,
            display: 'flex',
            alignItems: 'stretch',
        },
        downloadSegment: {
            borderRadius: 0,
        },
        downloadDivider: {
            width: 1,
            backgroundColor: palette.grey.level2,
        },
        sortLabel: {
            fontSize: 16,
            fontWeight: 500,
            '& .MuiTableSortLabel-icon': {
                opacity: 1,
            },
        },
        filterNumberIcon: {
            color: palette.text.lightContrast,
            background: palette.primary.main,
            padding: 5,
            lineHeight: 0.8,
            fontSize: '14px !important',
            borderRadius: 4,
        },
        downloadIcon: {
            marginRight: 5,
        },
        checkboxCompactWrapper: {
            display: 'flex',
            margin: -4,
        },
    };
});
exports.default = useStyles;
